import request from '@/utils/http';

/**
 * 获取信息
 * @param payload
 */
export function api_admin_user_info(payload) {
    return request({ url: '/AdminUser/info', method: 'post', data: payload })
}

/**
 * 分享人列表
 * @param payload
 */
export function share_user_list(payload) {
    return request({ url: '/AdminUser/shareUserList', method: 'post', data: payload })
}

/**
 * 分享操作
 * @param payload
 */
export function share_user_done(payload) {
    return request({ url: '/Article/shareUserDone', method: 'post', data: payload })
}

/**
 * 分享操作
 * @param payload
 */
export function check_user_auth(payload) {
    return request({ url: '/Article/checkUserAuth', method: 'post', data: payload })
}

/**
 * 部门列表
 * @param payload
 */
export function dept_list(payload) {
    return request({ url: '/AdminDept/lists', method: 'post', data: payload })
}

/**
 * 年限列表
 * @param payload
 */
export function year_list(payload) {
    return request({ url: '/Search/year_list', method: 'post', data: payload })
}

/**
 * 类别
 * @param payload
 */
export function data_type_list(payload) {
    return request({ url: '/Search/data_type', method: 'post', data: payload })
}

/**
 * cms列表
 * @param payload
 */
export function getArticleList(payload) {
    return request({ url: '/Article/lists', method: 'post', data: payload })
}

/**
 * 添加文档
 * @param payload
 */
export function articleCreate(payload) {
    return request({ url: '/Article/create', method: 'post', data: payload })
}

/**
 * 编辑文档
 * @param payload
 */
export function articleUpdate(payload) {
    return request({ url: '/Article/update', method: 'post', data: payload })
}

/**
 * 详情-编辑
 * @param payload
 */
export function getArticleDetail(payload) {
    return request({ url: '/Article/detail', method: 'post', data: payload })
}

/**
 * 栏目详情
 * @param payload
 */
export function categoryDetail(payload) {
    return request({ url: '/Category/read', method: 'post', data: payload })
}

/**
 * 上传
 * @param payload
 */
export let upload = process.env.VUE_APP_API_BASE_URL + '/storage/uploadfile';

/**
 * stsToken
 * @param payload
 */
export function getStsToken(payload) {
    return request({ url: '/search/getStsToken', method: 'post', data: payload })
}